import React, { useState, useEffect } from 'react';

// Owner-only. Backend also enforces this (403 for non-owners) — this
// component assumes its caller already checked isOwner before rendering it.
export default function ParallelRunSettings({ axios, C, card, sec, lbl, inp }) {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving]   = useState(false);
  const [parallelRun, setParallelRun] = useState(false);
  const [contactEmail, setContactEmail] = useState('');
  const [contactPhone, setContactPhone] = useState('');
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get('/api/rental-parallel-run').then(r => {
      setParallelRun(!!r.data.parallel_run);
      setContactEmail(r.data.parallel_run_contact_email || '');
      setContactPhone(r.data.parallel_run_contact_phone || '');
    }).catch(() => {}).finally(() => setLoading(false));
  }, [axios]);

  async function save(nextParallelRun) {
    setSaving(true); setError(''); setSaved(false);
    try {
      const r = await axios.put('/api/rental-parallel-run', {
        parallel_run: nextParallelRun ?? parallelRun,
        parallel_run_contact_email: contactEmail,
        parallel_run_contact_phone: contactPhone,
      });
      setParallelRun(!!r.data.parallel_run);
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch (e) { setError(e.response?.data?.error || 'Save failed'); }
    setSaving(false);
  }

  if (loading) return null;

  return (
    <div style={card}>
      <div style={sec}>🧪 Parallel-Run Mode</div>
      <div style={{ fontSize: 12, color: C.muted, marginBottom: 14 }}>
        While on, every customer-facing email/SMS (order confirmations, contract sends, reminders) is redirected to the contact below instead of the real customer — real customers are never contacted by test bookings.
      </div>

      <label style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', marginBottom: 16 }}>
        <input type="checkbox" checked={parallelRun} onChange={e => { setParallelRun(e.target.checked); save(e.target.checked); }}
          style={{ width: 18, height: 18, accentColor: C.accent, cursor: 'pointer' }} />
        <span style={{ fontSize: 13, fontWeight: 700, color: C.text }}>Parallel-run mode is {parallelRun ? 'ON' : 'OFF'}</span>
      </label>

      <label style={lbl}>Test messages are sent to — Email</label>
      <input style={{ ...inp, marginBottom: 10 }} type="email" placeholder="you@example.com" value={contactEmail} onChange={e => setContactEmail(e.target.value)} />

      <label style={lbl}>Test messages are sent to — Phone</label>
      <input style={{ ...inp, marginBottom: 10 }} type="tel" placeholder="+1 555 555 0100" value={contactPhone} onChange={e => setContactPhone(e.target.value)} />

      <div style={{ fontSize: 11, color: C.muted, marginBottom: 14 }}>
        Test messages are sent to: <strong style={{ color: C.text }}>{contactEmail || '—'}</strong> / <strong style={{ color: C.text }}>{contactPhone || '—'}</strong>
        {parallelRun && !contactEmail && !contactPhone && <span style={{ color: C.red }}> — nothing configured, every message will be suppressed.</span>}
      </div>

      <button type="button" onClick={() => save()} disabled={saving}
        style={{ padding: '9px 20px', borderRadius: 8, border: 'none', background: C.accent, color: '#fff', fontWeight: 700, fontSize: 13, cursor: 'pointer', opacity: saving ? 0.6 : 1 }}>
        {saving ? 'Saving…' : 'Save Contact'}
      </button>
      {saved && <span style={{ marginLeft: 10, fontSize: 12, color: C.green }}>✓ Saved</span>}
      {error && <div style={{ color: C.red, fontSize: 12, marginTop: 8 }}>{error}</div>}
    </div>
  );
}
